import { Trans } from "react-i18next";

import util from "utils/utils";

export default function CommentReacted({ events, ownerIdea }) {
  return (
    <Trans
      i18nKey="notifications.ideaCommentReacted"
      values={{
        name: util.getEventNames(events),
        idea: ownerIdea?.name || "Deleted",
      }}
      components={{ b: <b /> }}
    />
  );
}
